import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatCad } from "@shared/modules/x-atelier";
import { Card } from "../../../core/components/ui/card";
import { getStats, type AtelierStats } from "../lib/api";
import { addDays, formatHours, formatWeekRange, startOfWeek } from "../lib/dates";

/** Cette semaine : nombre de rendez-vous, heures planifiées et montant. */
export function WeekWidget() {
  const [stats, setStats] = useState<AtelierStats | null>(null);
  const [failed, setFailed] = useState(false);
  const now = new Date();

  useEffect(() => {
    const from = startOfWeek(new Date());
    getStats(from.toISOString(), addDays(from, 7).toISOString())
      .then((s) => {
        setStats(s);
        setFailed(false);
      })
      .catch(() => setFailed(true));
  }, []);

  return (
    <Card
      title="Cette semaine"
      subtitle={formatWeekRange(now)}
      actions={<Link to="/agenda">Ouvrir l'agenda</Link>}
    >
      {failed ? (
        <p className="atelier-widget__empty">Chiffres indisponibles pour l'instant.</p>
      ) : (
        <dl className="atelier-widget__stats">
          <div className="atelier-widget__stat">
            <dt className="atelier-widget__label">Rendez-vous</dt>
            <dd className="atelier-widget__value">{stats ? stats.appointmentCount : "—"}</dd>
          </div>
          <div className="atelier-widget__stat">
            <dt className="atelier-widget__label">Heures</dt>
            <dd className="atelier-widget__value">
              {stats ? formatHours(stats.durationMin) : "—"}
            </dd>
          </div>
          <div className="atelier-widget__stat">
            <dt className="atelier-widget__label">Montant</dt>
            <dd className="atelier-widget__value">{stats ? formatCad(stats.totalCents) : "—"}</dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
